module.exports = __webpack_public_path__ + "img/logo_quality.851c7a83.png";